import { ballArr, count, singleDouble, singleDoubleCnname, smallBig, continuity, continuityCnname, smallBigCnname, dragonTiger, fishCnname } from '../../../../helpers/resPatterns';
import dayjs from 'dayjs';

// let treeChildren = (index, data) => {
//   var arr = [];
//   if (data) {
//     for (let i = 0; i < 10; i++) {
//       var obj = {};
//       obj.title = `${i}`;
//       obj.align = 'center';
//       obj.width = '34';
//       obj.className = `tree_table_children_${index}`;
//       obj.render = (h, row) => {
//         // if (row.row.lostInfo[index][i] == 0) {
//         //   data[row.index].show = true;
//         //   return <span class="red">{data[row.index].issueResult[index]}</span>;
//         // } else {
//         //   return <span class="lost_info">{row.row.lostInfo[index][i]}</span>;
//         // }
//       };
//       arr.push(obj);
//     }
//     return arr;
//   }
// };
let treeChildren = (data, index) => {
  var arr = [];
  var shape = ['大', '小', '单', '双'];
  var str = ['big', 'small', 'single', 'double'];
  if (data) {
    for (let i = 0; i < shape.length; i++) {
      var obj = {};
      obj.title = `${shape[i]}`;
      obj.align = 'center';
      // obj.width = '37';
      obj.className = `join_table_children`;
      obj.render = (h, row) => {
        var name = `ball${index + 1}`;
        return <span>{row.row.ball_history_json[name][str[i]]}</span>;
      };
      arr.push(obj);
    }
    return arr;
  }
};

const ssc = data => {
  let list = Vue => {
    let arr = [
      {
        title: '日期',
        align: 'center',
        key: 'date',
        className: `table_issueId`,
        width: 150
      }
    ];
    var a = ['一', '二', '三', '四', '五', '六', '七', '八', '九'];
    var keys = Object.keys(data[0].ball_history_json);
    for (let i = 0; i < keys.length; i++) {
      let obj = {};
      let e = a[i];
      obj.title = `第${e}球`;
      obj.align = 'center';
      obj.width = '300';
      obj.key = 'resultStr';
      obj.className = `table_info_column_${i}`;
      obj.children = treeChildren(data, i);
      arr.push(obj);
    }
    return arr;
  };

  return { list };
};

export default ssc;



// WEBPACK FOOTER //
// ./src/pages/Trend/Longhutongji/columns/ssc.js